import get from 'lodash/get';
import React from 'react';

import { useComposablePage } from '../../helpers/composable';
import withBrandedComposablePage from '../../hocs/withBrandedComposablePage';
import ComposablePageLayout from '../../layouts/ComposablePageLayout';
import cardOverviewPage from './[slug]/data/CardOverviewPage.json';
import contentPageData from './[slug]/data/ContentPage.json';
import notFoundPageData from './[slug]/data/ContentPageNotFound.json';
import standalonePage from './[slug]/data/StandalonePage.json';
import BrandHomePageQuery from './BrandHomePage.gql';
import brandHomePageData from './BrandHomePage.json';

const getStandaloneData = (data) => {
  const type = get(data, 'brand.page.type');

  if (type === 'standalone') {
    return standalonePage;
  }

  return null;
};

const getPageData = (data) => {
  if (
    data.brand.slug === 'portal' &&
    data.brand?.page?.type === 'cardOverview'
  ) {
    return cardOverviewPage;
  }
  if (data.brand.slug === 'portal') {
    const standalonePageData = getStandaloneData(data);

    return standalonePageData || contentPageData;
  }

  return brandHomePageData;
};

const BrandHomePage = () => {
  const { data, render } = useComposablePage();
  const pageData = getPageData(data);

  const content = render(pageData, notFoundPageData);

  return <ComposablePageLayout>{content}</ComposablePageLayout>;
};

export default withBrandedComposablePage({
  query: BrandHomePageQuery,
  isFound: (data) => (data.brand.slug === 'portal' ? data.brand.page : true),
  formatData: (data) => {
    if (data.brand) {
      return data;
    }

    return {
      brand: data.portal,
    };
  },
})(BrandHomePage);
